import gql from 'graphql-tag'

const fetchDelegation = delegationId => {
	return {
		query: gql`
			query ($delegationId: bigint!) {
				delegation: organizations_delegations_by_pk(id: $delegationId) {
					delegation_name
					state_id
					zone_id
					cellphone
					phone
					email
				}
			}
		`,
		variables: { delegationId }
	}
}

export { fetchDelegation }
